import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {login} from "../../../api/AuthApi";
import {LoginResponse} from "../../../interfaces/interfaces";
import {useTranslation} from "react-i18next";

const Login = () => {
    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');
    const [error, setError]       = useState('');
    const navigate = useNavigate();
    const {t} = useTranslation()

    const handleLogin = async () => {
        try {
            const data: LoginResponse = await login({email, password});
            const token = data.token;
            localStorage.setItem("admin_token", token);
            navigate("/admin/dashboard");
        } catch (error) {
            setError(`${t("admin.login.invalid-credentials")}`);
        }
    }

    return (
        <div className="admin-login-page">
            <div className="admin-login-box">
                <div className="admin-login-logo">{t("admin.login.mariposa")}</div>
                <small>{t("admin.login.administration")}</small>
                {error && <div className="error-msg">{error}</div>}
                <input type="email"    placeholder={t("admin.login.email")}  value={email}    onChange={e => setEmail(e.target.value)} />
                <input type="password" placeholder={t("admin.login.password")}  value={password} onChange={e => setPassword(e.target.value)} />
                <button onClick={handleLogin}>{t("admin.login.login")}</button>
            </div>
        </div>
    );
};

export default Login;
